import { Piece } from "../actors/Actor";
import { HitParticle } from "./particles/HitParticle";
import { ParticleManager } from "./particleSystem";

export const hitPieces = async (
  pieces: Piece[],
  expectedOwner: number,
  cb?: (p: Piece) => void
) => {
  const reversed: Piece[] = [];
  pieces.forEach((piece) => {
    reversed.unshift(piece);
  });

  const destruction = [];
  for (let i = 0; i < reversed.length; i++) {
    const p = reversed[i];
    if (p.owner === expectedOwner) {
      destruction.push(
        ParticleManager.runThenDestroy(HitParticle, p.x, p.y, {
          fg: p.breed.fg,
        }).then(() => cb && cb(p))
      );
      if (i !== reversed.length - 1) {
        await new Promise((r) => {
          window.setTimeout(r, 50);
        });
      }
    }
  }
  await Promise.all(destruction);
};
